import { defineMessages } from 'react-intl-next';
export var linkMessages = defineMessages({
  openLink: {
    id: 'fabric.editor.openLink',
    defaultMessage: 'Open link in a new tab',
    description: 'Opens the link in a new tab'
  }
});